<div class="send-offer" [ngClass]="{'send-offer--with-button': sendCalculationEmailService.buttonVisible}">
    <app-send-offer-number [context]="context"></app-send-offer-number>

    <button *ngIf="sendButtonVisible"
            class="send-offer__btn btn btn--blue btn--small-padding"
            (click)="openDialog()">
        <img class="send-offer__btn__icon" [src]="buttonIconPath">
        <span class="send-offer__btn__text">{{sendCalculationEmailService.buttonLabel | translate}}</span>
    </button>
</div>
